import { useParams } from 'react-router-dom';
import { ProblemCollection } from '@/components/problems/ProblemCollection';
import { difficultyFromParam, difficultyPath } from '@/data/difficulties';
import { difficultyStructuredData } from '@/lib/structuredData';
import { NotFound } from './NotFound';

/** Qiyinlik sahifasi: /problems/difficulty/easy|medium|hard */
export function Difficulty() {
  const level = difficultyFromParam(useParams().level);
  if (!level) return <NotFound />;
  return (
    <ProblemCollection
      key={level.api}
      path={difficultyPath(level.api)}
      title={level.title}
      desc={level.desc}
      query={{ difficulty: level.api }}
      parent={{ to: '/problems', labelKey: 'nav.problems' }}
      jsonLd={difficultyStructuredData(level.title.uz, difficultyPath(level.api))}
    />
  );
}
